module.exports = __webpack_public_path__ + "static/media/neature.e7f17afb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appModule/neature.jpg
// module id = 2075
// module chunks = 108